<template>
    <div>
      <h2>Gerenciar Bairros</h2>
      <form @submit.prevent="fetchGeoJson">
        <div>
          <label for="city">Cidade</label>
          <input type="text" v-model="city" required />
        </div>
        <div>
          <label for="neighborhood">Bairro</label>
          <input type="text" v-model="neighborhood" required />
        </div>
        <button type="submit">Buscar GeoJSON</button>
      </form>
      <div v-if="geojson">
        <GmapMap
          :center="mapCenter"
          :zoom="12"
          style="width: 100%; height: 500px;"
        >
          <GmapPolygon
            v-for="(feature, index) in geojson.features"
            :key="index"
            :paths="getPolygonPaths(feature.geometry.coordinates)"
            :options="polygonOptions"
          />
        </GmapMap>
      </div>
    </div>
  </template>
  
  <script>
  import { GmapMap, GmapPolygon } from 'vue2-google-maps';
  
  export default {
    components: {
      GmapMap,
      GmapPolygon,
    },
    data() {
      return {
        city: '',
        neighborhood: '',
        geojson: null,
        mapCenter: { lat: -23.5505, lng: -46.6333 }, // Default coordinates (São Paulo)
        polygonOptions: {
          fillColor: '#FF0000',
          fillOpacity: 0.35,
          strokeColor: '#FF0000',
          strokeOpacity: 0.8,
          strokeWeight: 2,
        },
      };
    },
    methods: {
      async fetchGeoJson() {
        try {
          const response = await fetch(
            `/api/teste?city=${this.city}&neighborhood=${this.neighborhood}`
          );
          if (!response.ok) {
            throw new Error('GeoJSON not found');
          }
          const data = await response.json();
          this.geojson = data;
  
          // Update map center to the first point of the first polygon
          if (this.geojson.features.length > 0) {
            const firstFeature = this.geojson.features[0];
            if (firstFeature.geometry && firstFeature.geometry.coordinates.length > 0) {
              const firstCoordinate = firstFeature.geometry.coordinates[0][0];
              this.mapCenter = { lat: firstCoordinate[1], lng: firstCoordinate[0] };
            }
          }
        } catch (error) {
          console.error('Error fetching GeoJSON:', error);
        }
      },
      getPolygonPaths(coordinates) {
        return coordinates[0].map(coord => ({ lat: coord[1], lng: coord[0] }));
      },
    },
  };
  </script>
  
  <style>
  #map {
    height: 500px;
    width: 100%;
  }
  </style>
  